<template>
  <div class="container-fluid h-100">
    <div 
      :style="{ backgroundImage: 'url(' + image.url + ')' }" 
      class="content-register" 
      id="content1-register"
      title="Registro motero - havoline moto club"
      alt="Registro motero - havoline moto club"
    >
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
      >
        <!-- Texto que va sobre la imagen -->
        <div class="col-12 col-md-12 col-lg-6 col-xl-5 col-sm-12 padding-t2">
          <!-- Título -->
          <h1 class="club">
            {{ image.description != null ? image.description : '' }}
          </h1>
          <!-- Subtítulo -->
          <h2 class="ingresa">
            {{ image.subtitle != null ? image.subtitle : '' }}
          </h2>
          <h3 class="small-register">
            Si ya estás registrado, entra aquí
          </h3><br>
          <!-- Botón 1 -->
          <button
            v-if="image.button_1 != null ? image.button_1 : ''"
            @click="irRedirection(image.redirection_button_1)"
            class="btn btn-danger margin-btn mt-2 font-none"
          >
            {{ image.button_1 != null ? image.button_1 : '' }}
          </button><br>

          <!-- <hr class="mt-5" style="border-color:white;"> -->

          <!-- <h1 class="club">ÚNETE AL MOTOCLUB.</h1>
          <p class="ingresa">
            Ingresa tus datos para crear tu cuenta en el club y poder registrar
            tus códigos.
            <br>
            <small class="small-register">
              Si ya estás registrado, entra aquí
            </small>
            <br>
            <button class="btn btn-danger margin-btn mt-2 font-none" @click="irCode()">
              Inicia sesión
            </button>
          </p> -->
        </div>

        <div class=" col-12 col-md-12 col-lg-6 col-xl-7 col-sm-12  ">
          <div class="row p-row mt-3">
            <div class="col-12">
              <div class="row mt-4">
                <p class="p-text1" style="text-align:center; font-size:15px">
                  <strong>También puedes registrate con Google</strong>
                </p>
              </div>
              <div class="row mt-2">
                <div class="col-12 col-md-6 col-lg-6 col-xl-6 col-sm-6" style="padding:0px;">
                  <button
                    :disabled="loadingGoogle"
                    type="button"
                    @click="registerWithGoogle()"
                    class="btn btn-light btn-sm btn-block btn-register"
                    id="btn-register-id"
                  >
                    <span
                      v-if="loadingGoogle"
                      class="spinner-border spinner-border-md"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <template v-else>
                      <img alt="Google" src="@/assets/icon/google-24px.png" />
                      <!-- <i style="color:black;"> Google </i> -->
                    </template>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 small-info">
              <small
                >Recuerda que los datos marcados con (*) son obligatorios</small
              >
            </div>
            <div class="col-12 col-md-12 col-lg-4 col-xl-4 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3 ">
                  <select
                    v-model="form.documentType"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.documentType }"
                    id="exampleFormControlSelect1"
                    placeholder="Tipo de documento *"
                  >
                    <option value="0" disabled selected
                      >Tipo de documento *</option
                    >
                    <option
                      v-for="(item, i) in listTypeDocuments"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                      >{{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.documentType"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentType }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-4 col-xl-5 col-sm-12">
              <div class="form-group">
                <div class="input-group  mb-3">
                  <input
                    v-model="form.documentNumber"
                    type="text"
                    class="form-control color-input"
                    :class="{ 'is-danger': errors.documentNumber }"
                    aria-label="document"
                    placeholder="Número de documento * "
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.documentNumber"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentNumber }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-4 col-xl-3 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3 ">
                  <select
                    v-model="form.genderId"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.genderId }"
                    id="exampleFormControlSelect1"
                    placeholder="Genero *"
                  >
                    <option value="0" disabled selected>Género *</option>
                    <option
                      v-for="(item, i) in listGenders"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.genderId"
                  class="text-danger float-left small error-danger"
                  >{{ errors.genderId }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.name }"
                    v-model="form.name"
                    type="text"
                    class="form-control color-input"
                    aria-label="name"
                    placeholder="Nombres *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.name"
                  class="text-danger float-left small error-danger"
                  >{{ errors.name }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.lastName }"
                    v-model="form.lastName"
                    type="text"
                    class="form-control color-input"
                    aria-label="lastName"
                    placeholder="Apellidos *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.lastName"
                  class="text-danger float-left small error-danger"
                  >{{ errors.lastName }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group  mb-3">
                  <select
                    v-model="form.state"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.state }"
                    id="exampleFormControlSelect1"
                  >
                    <option disabled value="0" selected>Departamento *</option>
                    <option
                      v-for="(item, i) in listDocuments"
                      :value="item.id"
                      class=" color-option"
                      :key="'st' + i"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.state"
                  class="text-danger float-left small error-danger"
                  >{{ errors.state }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                    v-model="form.cityId"
                    :disabled="showCities"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.cityId }"
                    id="exampleFormControlSelect1"
                  >
                    <option value="0" disabled selected>Ciudad *</option>
                    <option
                      v-for="(item, i) in listCities"
                      :key="'ci' + i"
                      :value="item.id"
                      class=" color-option"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.cityId"
                  class="text-danger float-left small error-danger"
                  >{{ errors.cityId }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.phone }"
                    type="number"
                    v-model="form.phone"
                    class="form-control color-input"
                    aria-label="phone"
                    placeholder="Teléfono *"
                    aria-describedby="basic-addon1"
                    @input="onInput"
                  />
                </div>
                <span
                  v-if="errors.phone"
                  class="text-danger float-left small error-danger"
                  >{{ errors.phone }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.email }"
                    v-model="form.email"
                    type="text"
                    class="form-control color-input"
                    aria-label="email"
                    placeholder="email *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.email"
                  class="text-danger float-left small error-danger"
                  >{{ errors.email }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.birthdate }"
                    type="text"
                    v-model="form.birthdate"
                    class="form-control color-input"
                    placeholder="fecha de nacimiento *"
                    :min="minDate()"
                    :max="maxDate()"
                    onfocus="(this.type='date')"
                  />
                </div>
                <span
                  v-if="errors.birthdate"
                  class="text-danger float-left small error-danger"
                  >{{ errors.birthdate }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                      v-model="form.motorcycleBrand"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.motorcycleBrand }"
                      id="motorcycleBrand"
                  >
                    <option value="0" disabled selected>Marca de tu Moto *</option>
                    <option v-for="item in listBrands" :key="item.id" :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleBrand"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleBrand }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12" v-if="form.motorcycleBrand == 44">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                      :class="{ 'is-danger': errors.motorcycleBrandOther }"
                      v-model="form.motorcycleBrandOther"
                      type="text"
                      class="form-control color-input"
                      aria-label="text"
                      placeholder="¿Cúal? (Escriba la marca de su moto) *"
                      aria-describedby="basic-addon1"
                  />
                </div>
                <span
                    v-if="errors.motorcycleBrandOther"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleBrandOther }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                      v-model="form.motorcycleCylinder"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.motorcycleCylinder }"
                      id="motorcycleCylinder"
                  >
                    <option value="0" disabled selected>Cilindraje de tu Moto *</option>
                    <option v-for="item in listCylinders" :key="item.id" :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleCylinder"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleCylinder }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                      v-model="form.motorcycleUse"
                      class="form-control color-input select-input"
                      :class="{ 'is-danger': errors.motorcycleUse }"
                      id="motorcycleUse"
                  >
                    <option value="0" disabled selected>Uso de tu Moto *</option>
                    <option v-for="item in listUses" :key="item.id" :value="item.id" class="color-option" >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <span
                    v-if="errors.motorcycleUse"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleUse }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12" v-if="form.motorcycleUse == 4">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                      :class="{ 'is-danger': errors.motorcycleUseOther }"
                      v-model="form.motorcycleUseOther"
                      type="text"
                      class="form-control color-input"
                      aria-label="text"
                      placeholder="¿Cúal? (Escriba el uso de su moto) *"
                      aria-describedby="basic-addon1"
                  />
                </div>
                <span
                    v-if="errors.motorcycleUseOther"
                    class="text-danger float-left small error-danger"
                >{{ errors.motorcycleUseOther }}</span
                >
              </div>
            </div>
            <div
              class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12"
              style="text-align: left;"
            >
              <label class="password-text"
                >Crea una nueva contraseña para ingresar al club</label
              >
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.pass }"
                    v-model="form.pass"
                    type="password"
                    ref="password"
                    class="form-control color-input"
                    aria-label="password"
                    placeholder="Contraseña *"
                    aria-describedby="basic-addon1"
                  />
                  <div @click="showPass(1)" class="eye_pass">
                    <span id="pass1" class="fa-regular fa-eye-slash"></span>
                  </div>
                </div>
                <span
                  v-if="errors.pass"
                  class="text-danger float-left small error-danger"
                  >{{ errors.pass }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.passCon }"
                    v-model="form.passCon"
                    type="password"
                    ref="confirm_password"
                    class="form-control color-input"
                    aria-label="passwordC"
                    placeholder="Confirmar contraseña *"
                    aria-describedby="basic-addon1"
                  />
                  <div @click="showPass(2)" class="eye_pass">
                    <span id="pass2" class="fa-regular fa-eye-slash"></span>
                  </div>
                </div>
                <span
                  v-if="errors.passCon"
                  class="text-danger float-left small error-danger"
                  >{{ errors.passCon }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
              <table class="mb-2 table-register">
                <caption class="visually-hidden">TyC</caption>
                <tr hidden>
                  <th id="au-1">Acción</th>
                  <th id="au-2">Texto</th>
                </tr>
                <tr>
                  <td>
                    <input
                      :class="{ 'is-danger': errors.check }"
                      v-model="form.check"
                      style="cursor: pointer"
                      type="checkbox"
                      name="checkbox"
                      id="checkbox1"
                    />
                  </td>
                  <td class="pl-3" style="text-align: left">
                    <a class="condiciones" :href="file" target="_blank"
                      ><label> Acepta términos y condiciones *</label></a
                    >
                    <br />
                    <span
                      v-if="errors.check"
                      class=" text-danger float-left small error-danger "
                      style="padding-top: 11px;"
                      >{{ errors.check }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      v-model="form.checkMail"
                      type="checkbox"
                      name="checkbox"
                      id="checkbox1"
                    />
                  </td>
                  <td class="pl-3" style="text-align: left">
                    Me gustaría recibir noticias sobre productos y servicios de
                    Havoline Motoclub Te Cubre a través de e-mail y SMS.
                  </td>
                </tr>
              </table>

              <button
                :disabled="disableLoading"
                type="button"
                @click="saveUser()"
                class="btn btn-danger btn-sm btn-block btn-register"
                id="btn-register-id"
              >
                <span
                  v-if="disableLoading"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <template v-else>REGÍSTRATE</template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para ir a las redes sociales de HavolineColombia -->
    <div
      class="modal fade"
      id="modalRRSS"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div style="min-width:45%;" class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modalRRSS" alt="fondo modal redes">
          <div class="content_btn_close">
            <img
              src="../../assets/iconsRRSS/logo_close.png"
              width="20"
              title="cerrar popup"
              alt="cerrar popup"
              @click="closedModal()"
            />
          </div>
          <div style="margin-top:20px;" class="mr-md-4">
            <img
              src="../../assets/iconsRRSS/logo_havoline.png"
              width="150"
              title="logo havoline"
              alt="logo havoline"
            />
          </div>
          <div class="modal_content_rrss">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              style="color:#6c757d; margin:auto;"
            >
              <span class="text_white">Síguenos en nuestras redes </span><span class="text_yellow">para que no <br> te pierdas de todo nuestro contenido.</span>
            </h5>
          </div>
          <div style="margin:auto;" class="modal_footer_rrs">
            <div class="row pt-4 pb-3 d-flex justify-content-center">
              <div class="">
                <a href="https://www.instagram.com/havolinecolombia" target="_blank" rel="noopener noreferrer">
                  <img 
                    height="40" 
                    width="40" 
                    src="../../assets/iconsRRSS/logo_instagram.png"
                    title="Instagram HavolineColombia"
                    alt="Instagram HavolineColombia"
                  />
                </a>
                <a href="https://www.facebook.com/HavolineColombia/" target="_blank" rel="noopener noreferrer"> 
                  <img
                    style="margin-left:15px"
                    height="40"
                    width="40"
                    src="../../assets/iconsRRSS/logo_facebook.png"
                    title="Facebook HavolineColombia"
                    alt="Facebook HavolineColombia"
                  />
                </a>
                <a href="https://www.youtube.com/ChevronColombia/" target="_blank" rel="noopener noreferrer"> 
                  <img
                    style="margin-left:15px"
                    height="40"
                    width="40"
                    src="../../assets/iconsRRSS/logo_youtube.png"
                    title="YouTube HavolineColombia"
                    alt="YouTube HavolineColombia"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../../config/auth";
import axios from "axios";
import $ from "jquery";
// import CryptoJS from "crypto-js";

export default {
  name: "contentLanding",
  data() {
    return {
      listBrands: [],
      listCylinders: [],
      listUses: [],
      listGenders: [],
      listDistributor: [],
      showProfiles: {
        classBiker: "btn-danger",
        classLubricator: "btn-danger",
        biker: true,
        lubricator: true,
      },
      listDocuments: [],
      listCities: [],
      listTypeDocuments: [],
      form: {
        distributorId: 0,
        documentType: 0,
        documentNumber: "",
        genderId: 0,
        name: "",
        lastName: "",
        state: 0,
        cityId: 0,
        phone: "",
        email: "",
        birthdate: null,
        motorcycleBrand: 0,
        motorcycleBrandOther: "",
        motorcycleCylinder: 0,
        motorcycleUse: 0,
        motorcycleUseOther: "",
        pass: "",
        passCon: "",
        check: false,
        checkMail: false,
        link: null,           
      },
      errors: {
        distributorId: false,
        documentType: false,
        documentNumber: false,
        genderId: 0,
        name: false,
        lastName: false,
        state: false,
        cityId: false,
        phone: false,
        email: false,
        birthdate: false,
        motorcycleBrand: 0,
        motorcycleBrandOther: "",
        motorcycleCylinder: 0,
        motorcycleUse: 0,
        motorcycleUseOther: "",
        pass: false,
        passCon: false,
        check: false,
      },
      showCities: true,
      disableLoading: false,
      file: null,
      imgsBackground: [],
      imgBack: [],
      image: {},
      loadingGoogle: false,
      ip_address: 0
    };
  },
  methods: {
    minDate() {
      const now = new Date();
      now.setFullYear(now.getFullYear() - 100);
      return now.toISOString().substr(0, 10);
    },
    maxDate(){
      const now = new Date();
      now.setFullYear(now.getFullYear() - 18);
      return now.toISOString().substr(0, 10);
    },
    getBrands(){
      axios
      .get("api/motorcycleBrands/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listBrands = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    getMotorcycleUses() {
      axios
      .get("api/motorcycleUses/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listUses = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    getMotorcycleCylinder() {
      axios
      .get("api/motorcycleCylinder/get")
      .then((res) => {
        if (res.data.cod == 0) {
          this.listCylinders = res.data.data;
        }
      })
      .catch((error) => {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    getGenders() {
      axios
        .get("api/getGenders")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listGenders = res.data.data;
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getDocuments() {
      axios
        .get("api/files/active/" + 1)
        .then((res) => {
          if (res.data.cod == 0) {
            this.file = res.data.data[0].url;
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    distributorList() {
      var app = this;
      axios
        .get("api/distributorList")
        .then(function(res) {
          if (res.data.cod == 0) {
            app.listDistributor = res.data.data;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    irCode() {
      let sesion = sessionStorage.getItem("token");
      if (sesion == "" || sesion == null) {
        this.$router.push({ name: "login" });
      } else {
        this.$router.push({ name: "homeUser" });
      }
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listDocuments = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.showCities = false;
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    saveUser() {
      // var code = this.$route.params.code;
      var campaign = this.$route.query.utm_campaign;
      var source = this.$route.query.utm_source;
      var mediun = this.$route.query.utm_medium;
      if (campaign != undefined) {
        this.form.campaign = campaign;
      }
      if (source != undefined) {
        this.form.source = source;
      }
      if (mediun != undefined) {
        this.form.mediun = mediun;
      }

      if (this.form.checkMail) {
        this.form.checkMail = 1;
      } else {
        this.form.checkMail = 0;
      }

      if (this.form.checkMail) {
        this.form.checkMail = 1;
      } else {
        this.form.checkMail = 0;
      }

      // if (code == undefined) {
      //   this.form.code = null;
      // } else {
      //   this.form.code = code;
      // }

      if (this.validform()) {
        var app = this;
        app.disableLoading = true;
        // console.log('app.form ', JSON.stringify(app.form));
        axios
          .post("api/signup", app.form)
          .then(function(res) {
            app.disableLoading = false;
            if (res.data.cod == 0) {
              localStorage.setItem('sms', res.data.message);
              app.$router.push({ name: "thankyou", params: { event_origin: "Registro con formulario principal" } });
            } else {
              app.$swal({
                icon: res.data.IconAlert ? res.data.IconAlert : "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
                confirmButtonColor: "#dc3545"
              });
            }
          })
          .catch(function(error) {
            app.disableLoading = false;
            app.$swal({
              icon: "error",
              title: "Oops...",
              text: "Ocurrió un error al registrar la información"
            });
          });
      }
    },
    registerWithGoogle() {
      this.$swal({
        icon: "info",
        title: "Información importante",
        html: "Al continuar con el registro mediante el botón de Google, serás registrado con el rol de <strong>Motero</strong> en la plataforma.<br> ¿Desea continuar?",
        confirmButtonText: "Sí, continuar",
        confirmButtonColor: "#1da5df",
        showCancelButton: true,
        cancelButtonText: "No, cancelar",
        cancelButtonColor: "#dc3545"
      }).then((result) => {
        if(result.isConfirmed){
          this.$gapi.login().then(({ currentUser }) => {
            // console.log('currentUser: ', JSON.stringify(currentUser));
            var profileUser = currentUser.getBasicProfile();
            var profileU = Object.values(profileUser);
            // console.log('profileU: ', profileU);
            let id_token = currentUser.getAuthResponse().id_token;
            this.data = {
              name: profileU[2],
              last_name: profileU[3],
              email: profileU[5],
              token: id_token,
              link: this.form.link
            };
            this.loadingGoogle = true;
            axios
              .post("api/signup/google", this.data)
              .then(async res => {
                if (res.data.cod == 0) {
                  login(res.data.data.access_token);
                  this.$swal({
                    icon: "success",
                    title: "Muy bien",
                    html: res.data.message + "<br> ¡Vamos a completar tu información personal!",
                    confirmButtonText: "Vamos",
                    confirmButtonColor: "#1da5df",
                    showCancelButton: true,
                    cancelButtonText: "En otra ocasión",
                    cancelButtonColor: "#dc3545"
                  }).then((result) => {
                    if(result.isConfirmed){
                      this.$router.push({ name: "registerGoogle" });
                    }
                  });
                  this.sendEvent();
                } else {
                  this.$swal({
                    icon: res.data.IconAlert ? res.data.IconAlert : "error",
                    title: "Oops...",
                    text: res.data.ResponseMessage,
                    confirmButtonColor: "#dc3545"
                  });
                }
                this.loadingGoogle = false;
              })
              .catch(error => {
                // console.log('error ', JSON.stringify(error));
                this.$swal({
                  icon: "info",
                  title: "Oops...",
                  html: error.response.data.message,
                  confirmButtonText: 'OK',
                  confirmButtonColor: "#dc3545"
                });
                this.loadingGoogle = false;
              });
          });
        }
      });
    },
    saveUserLubricator() {
      if (this.validform()) {
        var app = this;
        if (this.form.distributorId == 0) {
          this.errors.distributorId = "El distribuidor es requerido.";
        } else {
          this.errors.distributorId = false;
        }
        this.disableLoading = true;
        axios
          .post("api/signupLubricator", this.form)
          .then(function(res) {
            if (res.data.cod == 0) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              app.$router.push({ name: "landingPage" });
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
              });
            }
            app.disableLoading = false;
          })
          .catch(function(error) {
            console.log(error);
            app.$swal({
              icon: "error",
              title: "Oops...",
              text: "Error al registrar la información",
            });
            app.disableLoading = false;
          });
      }
    },
    validform() {
      let app = this;

      if (!app.form.documentType) {
        app.errors.documentType = "El tipo de documento es requerido.";
        return false;
      }
      if (!app.form.documentNumber) {
        app.errors.documentNumber = "El númnero de documento es requerido.";
        return false;
      }
      if (!app.form.genderId) {
        app.errors.genderId = "El género es requerido.";
        return false;
      }
      if (!app.form.name) {
        app.errors.name = "Los nombres son requeridos.";
        return false;
      }
      if (!app.form.lastName) {
        app.errors.lastName = "Los apellidos son requeridos.";
        return false;
      }
      if (!app.form.state) {
        app.errors.state = "El departamento es requerido.";
        return false;
      }
      if (!app.form.cityId) {
        app.errors.cityId = "La ciudad es requerida.";
        return false;
      }
      if (!app.form.phone) {
        app.errors.phone = "El número de teléfono es requerido.";
        return false;
      }
      if (!app.form.email) {
        app.errors.email = "El email es requerido.";
        return false;
      }
      if (!app.form.birthdate) {
        app.errors.birthdate = "La fecha de nacimiento es requerida.";
        return false;
      }
      if (app.form.motorcycleBrand == 0) {
        app.errors.motorcycleBrand = "La marca de tu moto es requerida.";
        return false;
      }
      if (app.form.motorcycleBrand == 44) {
        if (!app.form.motorcycleBrandOther) {
          app.errors.motorcycleBrandOther = "La marca de tu moto es requerida.";
          return false;
        }
      }
      if (app.form.motorcycleCylinder == 0) {
        app.errors.motorcycleCylinder = "El cilindraje de tu moto es requerido.";
        return false;
      }
      if (app.form.motorcycleUse == 0) {
        app.errors.motorcycleUse = "El uso de tu moto es requerido.";
        return false;
      }
      if (app.form.motorcycleUse == 4) {
        if(!app.form.motorcycleUseOther){
          app.errors.motorcycleUseOther = "El uso de tu moto es requerido.";
          return false;
        }
      }
      if (!app.form.pass) {
        app.errors.pass = "La contraseña es requerida.";
        return false;
      }
      if (!app.form.passCon) {
        app.errors.passCon = "La contraseña es requerida.";
        return false;
      }
      if (app.form.passCon != this.form.pass) {
        app.errors.passCon = "Las contraseñas deben ser iguales";
        return false;
      }
      if (!app.form.check) {
        app.errors.check = "Debe aceptar términos y condiciones";
        return false;
      }
      if (
        !app.errors.documentType &&
        !app.errors.documentNumber &&
        !app.errors.genderId &&
        !app.errors.name &&
        !app.errors.lastName &&
        !app.errors.state &&
        !app.errors.cityId &&
        !app.errors.phone &&
        !app.errors.email &&
        !app.errors.birthdate &&
        app.form.motorcycleBrand &&
        !app.form.motorcycleBrandOther &&
        app.form.motorcycleCylinder &&
        app.form.motorcycleUse &&
        !app.form.motorcycleUseOther &&
        !app.errors.pass &&
        !app.errors.passCon &&
        !app.errors.check &&
        !app.validEmail(app.errors.email) &&
        !app.validPhone(app.errors.phone) &&
        // !app.validPlate(app.errors.plate) &&
        !app.validPassword(app.errors.pass)
      ) {
        return true;
      }
      return false;
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone(phone) {
      var re = /^[0-9]{10,10}$/;
      return re.test(phone);
    },
    onInput(e) {
      let value = e.target.value.toString();
      value = value.replace(/[^0-9]/g, '');
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
      this.form.phone = value;
    },
    validPassword(pass) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(pass);
    },
    getImgsBackground(){
      let app = this;
      axios
      .get('api/file/imgsBackground')
      .then((response) => {
        if(response.data.cod == 0){
          app.imgsBackground = response.data.data;
          app.imgsBackground.forEach(element => {
            if(element.type_view == 8){
              app.imgBack.push(element);
              app.getImage();
            }
          });
        } else {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: response.data.ResponseMessage
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    getImage(){
      const ancho = window.innerWidth;
      let newImage = null;
      // Buscar la imagen correspondiente al tamaño actual de la pantalla
      if(ancho <= 480) {
        newImage = this.imgBack.find(img => img.size === 7);
      } else if(ancho > 480 && ancho <= 780) {
        newImage = this.imgBack.find(img => img.size === 6);
      } else if(ancho > 780) {
        newImage = this.imgBack.find(img => img.size === 5);
      }
      // Actualizar la imagen de fondo solo si es diferente a la actual
      if(newImage && (!this.image || newImage.url !== this.image.url)) {
        this.image = newImage;
      }
    },
    irRedirection(url) {
      if (url != null && url != '') {
        var a = document.createElement('a');
        a.href=url;
        a.click();
      }
    },
    closedModal(){
      $("#modalRRSS").modal("hide");
    },
    showPopup(){
      if(localStorage.getItem('flagUpdateData') == 0 && localStorage.getItem('flagRegisterData') == 0){
        if (!sessionStorage.getItem('modalRRSS2')){
          $("#modalRRSS").modal("show");
          sessionStorage.setItem('modalRRSS2', 1);
        }
      }
    },
    showPass(type){
      if(type == 1){
        let pass = this.$refs.password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass1').addClass('fa-eye');
          $('#pass1').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass1').addClass('fa-eye-slash');
          $('#pass1').removeClass('fa-eye');
        }
      } else {
        let pass = this.$refs.confirm_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass2').addClass('fa-eye');
          $('#pass2').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass2').addClass('fa-eye-slash');
          $('#pass2').removeClass('fa-eye');
        }
      }
    },
    getIp(){
      axios
      .get("https://ipinfo.io/json")
      .then((res) => {
        if(res.status == 200){
          this.ip_address = res.data.ip;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
    sendEvent(){
      axios
      .post("api/send-data-event", {
        event_name: "Registro principal con Google",
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: document.URL,
        action_source: "website",
        user_data: {
          client_ip_address: this.ip_address,
          client_user_agent: window.navigator.userAgent
        }
      })
      .then(() => {
        console.log("Evento de registro principal con Google enviado correctamente.");
      })
      .catch((err) => {
        console.log("Error enviando el evento:", err);
      });
    },
  },
  watch: {
    "form.documentType": function(n) {
      if (n != 0) {
        this.errors.documentType = false;
      } else {
        this.errors.documentType = "El tipo de documento es requerido.";
      }
    },
    "form.documentNumber": function(n) {
      if (n) {
        this.errors.documentNumber = false;
      } else {
        this.errors.documentNumber = "El número de documento es requerido.";
      }
    },
    "form.genderId": function(n) {
      if (n != 0) {
        this.errors.genderId = false;
      } else {
        this.errors.genderId = "El género es requerido.";
      }
    },
    "form.name": function(n) {
      if (n) {
        this.errors.name = false;
      } else {
        this.errors.name = "Los nombres son requeridos.";
      }
    },
    "form.lastName": function(n) {
      if (n) {
        this.errors.lastName = false;
      } else {
        this.errors.lastName = "Los apellido son requeridos.";
      }
    },
    "form.state": function(n) {
      this.getCities(n);
      if (n == 0) {
        this.errors.state = "El departamento es requerido.";
      } else {
        this.errors.state = false;
      }
    },
    "form.cityId": function(n) {
      if (n != 0) {
        this.errors.cityId = false;
      } else {
        this.errors.cityId = "La ciudad es requerida.";
      }
    },
    "form.phone": function(n) {
      if (!n) {
        this.errors.phone = "El teléfono es requerido.";
      } else if (!this.validPhone(n)) {
        this.errors.phone = "El teléfono es inválido.";
      } else {
        this.errors.phone = false;
      }
    },
    "form.email": function(n) {
      if (!n) {
        this.errors.email = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errors.email = "El email es inválido.";
      } else {
        this.errors.email = false;
      }
    },
    "form.birthdate": function(n) {
      if (n != 0) {
        this.errors.birthdate = false;
      } else {
        this.errors.birthdate = "La fecha de nacimiento es requerida.";
      }
    },
    "form.motorcycleBrand": function(n) {
      if (n != 0) {
        this.errors.motorcycleBrand = false;
      } else {
        this.errors.motorcycleBrand = "La marca de tu moto es requerida.";
      }
    },
    "form.motorcycleBrandOther": function(n) {
      if (n) {
        this.errors.motorcycleBrandOther = false;
      } else {
        this.errors.motorcycleBrandOther = "La marca de tu moto es requerida.";
      }
    },
    "form.motorcycleCylinder": function(n) {
      if (n != 0) {
        this.errors.motorcycleCylinder = false;
      } else {
        this.errors.motorcycleCylinder = "El cilindraje de tu moto es requerido.";
      }
    },
    "form.motorcycleUse": function(n) {
      if (n != 0) {
        this.errors.motorcycleUse = false;
      } else {
        this.errors.motorcycleUse = "El uso de tu moto es requerido.";
      }
    },
    "form.motorcycleUseOther": function(n) {
      if (n) {
        this.errors.motorcycleUseOther = false;
      } else {
        this.errors.motorcycleUseOther = "El uso de tu moto es requerido.";
      }
    },
    "form.pass": function(n) {
      if (!n) {
        this.errors.pass = "La contraseña es requerida.";
      } else if (!this.validPassword(n)) {
        this.errors.pass =
          "La contraseña es inválida, debe tener entre 8 a 16 carácteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.";
      } else {
        this.errors.pass = false;
      }
      if (this.form.passCon == this.form.pass) {
        this.errors.passCon = false;
      } else {
        this.errors.passCon = "Las contraseñas deben ser iguales";
      }
    },
    "form.passCon": function() {
      if (this.form.passCon == this.form.pass) {
        this.errors.passCon = false;
      } else {
        this.errors.passCon = "Las contraseñas deben ser iguales";
      }
    },
    "form.check": function() {
      if (!this.form.check) {
        this.errors.check = "Debe aceptar términos y condiciones";
      } else {
        this.errors.check = false;
      }
    },
    "form.distributorId": function(n) {
      if (n != 0) {
        this.errors.distributorId = false;
      } else {
        this.errors.distributorId = "El distribuidor es requerido.";
      }
    },
  },
  eforeDestroy() {
    // Eliminar el listener de resize antes de destruir el componente
    window.removeEventListener('resize', this.getImage);
  },
  async mounted() {
    this.getImgsBackground();
    // Detectar cuando cambia el tamaño de la pantalla
    window.addEventListener('resize', this.getImage);
    this.getGenders();
    this.getDocuments();
    this.distributorList();
    this.getListStates();
    this.getTypeDocuments();
    this.getBrands();
    this.getMotorcycleUses();
    this.getMotorcycleCylinder();
    this.form.link = localStorage.getItem('link');
    setTimeout(() => {
      this.showPopup();
    }, 500);
    this.getIp();
  },
};
</script>

<style scoped>
.content-register {
  padding-left: 5%;
  padding-top: 10%;
  padding-bottom: 10%;
  height: 100%;
}
.table-register {
  margin-left: 10%;
}
.small-register {
  font-family: "GothamBoldItalic", sans-serif !important;
  font-size: 13px;
  float: left;
}
.btn-danger{
  float: left;
}
.club {
  font-size: 55px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left;
}
.password-text {
  font-family: "GothamBoldItalic", sans-serif;
}
.ingresa {
  font-size: 18px;
  text-align: left;
  font-family: "GothamBookItalic", sans-serif;
}
.t-c {
  text-align: center;
}
#content1-register {
  background-size: cover;
  background-image: url("../../assets/img/03.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}
a.condiciones {
  text-align: left !important;
  cursor: pointer !important;
  color: white;
  border-bottom: 1px solid;
}
.font-none {
  font-family: "Arial", sans-serif;
}
.condiciones:hover {
  color: #b3b3b3 !important;
  /* border-bottom: 1px solid; */
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0px 15px !important;
}
.color-select {
  font-size: 13px;
  height: 30px !important;
  position: relative;
  padding: 0px 15px !important;
}
.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-option {
  color: black !important;
}
.color-option:active {
  background-color: crimson !important;
}
.icon-disable {
  color: #676565 !important;
}
.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}
.small-info {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px !important;
}
.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}
.modalRRSS{
  background-image: url('../../assets/iconsRRSS/fondo_modalrrss.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.modal_content_rrss, .modal_footer_rrs{
  padding: 20px 15px 30px 15px;
}
.content_btn_close{
  margin: 20px 25px auto auto;
  cursor: pointer;
}
.text_white{
  color: white;
  font-weight: bold;
}
.text_yellow{
  color: #ffce00;
  font-weight: bold;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
input[type=number] {
  -moz-appearance: textfield;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .color-input {
    padding: 0px 15px !important;
  }
  .content-register {
    height: 100%;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .content-register {
    height: 100%;
  }
  .padding-t2 {
    padding-top: 13%;
    padding-bottom: 8%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }
  .table-register {
    margin-left: 0%;
  }
  .content-register {
    padding-left: 0%;
    padding-top: 50%;
    padding-bottom: 30%;
  }
  .club {
    font-size: 40px;
    text-align: left;
  }
  .ingresa {
    font-size: 18px;
    text-align: left;
  }
  .margin-btn {
    margin-bottom: 35%;
  }
}
</style>
